import { useState, useEffect, useRef } from "react";
import { Form, Modal, Row, Col, Alert } from "react-bootstrap";
import { BiSelectMultiple } from "react-icons/bi";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import SingleValuePopUp from "../utility/ui/modals/SingleValuePopUp";
import { AddNewUser, UpdateUser } from "../../Services/user-service";
import { RenderIf } from "../../functions/welding-functions";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import { isAlphanumericWithSpace, isAlphanumericWithDot, isNumber, isAlphanumericAllSpecialCharacters } from "../../functions/validations";
import { getPresignedURL } from "../../Services/Welder-services";
import axios from "axios";
import ButtonModal from "../Modals/buttonModal";
import Delete from "../../icons/DeleteIcon.svg";
import { getRoleDescByRoleId } from "../../Services/role-service";
import { validateFile } from "../utility/common/TransactionComponents/CommonImages";

// Helper function to normalize status
const normalizeStatus = (rowdata) => {
  const normalizedData = { ...rowdata };
  normalizedData.um_status = rowdata.um_status === "Active";
  return normalizedData;
};

const AddEditUserMaster = (props) => {
  const normalizedRowData = normalizeStatus(props.rowdata);
  let action = props.action;
  let formName = "User";
  let folderName = "wld_signatures";
  const [show1, setShow1] = useState(false);
  const show = false;
  const [alertMessage, setAlertMessage] = useState("");
  const [profile, setProfile] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [popUp, setPopUp] = useState({
    name: "",
    type: "",
    key: "",
    value: "",
  });

  const [userObj, setuserObj] = useState(
    action === "Edit"
      ? normalizedRowData
      : {
        um_status: true,
        um_name: "",
        um_role: "",
        um_email: "",
        um_contactNumber: "",
        um_location: "",
        createdby: "",
        PK: "",
        SK: "",
        wld_profile: "",
        um_empSalCode: "",
      }
  );


  const handleCloseConf = () => {
    setShow1(false);
  };

  const [error, setError] = useState({
    um_status: {},
    SK: {},
    um_name: {},
    um_email: {},
    um_contactNumber: {},
    um_role: {},
    um_location: {},
  });

  const validateInput = () => {
    let result = false;
    if (action === "Add") {
      result = props.allRecs.find(
        (item) =>
          item.um_email.toLowerCase() === userObj.um_email.toLowerCase() ||
          item.PK.toLowerCase() === userObj.PK.toLowerCase()
      );
      if (result) {
        setAlertMessage("User with same User Id");
        return false;
      } else {
        return true;
      }
    }
    return true;
  };

  const validate = async () => {
    let isError = false;
    let role;
    role = await getRoleDescByRoleId(userObj.um_role)
      .then(function (role) {

        return role;
      })
      .catch(function (error) {
        console.log(error);
      });

    if (userObj.SK === "") {
      isError = true;
      error.SK = {
        status: true,
        message: "User ID is required",
      };
    }
    if (userObj.um_name === "") {
      isError = true;
      error.um_name = {
        status: true,
        message: "User name is required",
      };
    }
    if (userObj.um_location === "") {
      isError = true;
      error.um_location = {
        status: true,
        message: "User Location is required ",
      };
    }
    if (userObj.um_role === "") {
      isError = true;
      error.um_role = {
        status: true,
        message: "User role required",
      };
    }
    if (
      role != undefined &&
      role[0] != undefined &&
      role[0].rm_status == "Inactive"
    ) {
      isError = true;
      error.um_role = {
        status: true,
        message: "User role Inactive",
      };
    }
    if (userObj.um_email === "") {
      isError = true;
      error.um_email = {
        status: true,
        message: "Email Address is required",
      };
    }
    if (userObj.um_contactNumber === "") {
      isError = true;
      error.um_contactNumber = {
        status: true,
        message: "Official mobile no. is required",
      };
    }

    setError((prevState) => ({
      ...prevState,
      ...error,
    }));

    if (
      error.um_email.status ||
      error.um_contactNumber.status ||
      error.um_role.status ||
      error.um_name.status ||
      error.SK.status
    )
      isError = true;

    return isError;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setuserObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setError((prevState) => ({
      ...prevState,
      um_role: {},
      SK: {},
    }));
  };

  const handleSwitchChange = (e) => {
    setuserObj((prevState) => ({
      ...prevState,
      um_status: e.target.checked,
    }));
  };

  const resetForm = (e) => {
    if (action === "Add") {
      setuserObj((prevState) => ({
        ...prevState,
        SK: "",
        um_status: true,
        um_name: "",
        um_role: "",
        um_email: "",
        um_contactNumber: "",
        um_location: "",
        um_band: "",
        um_empSalCode: "",
      }));
      setError((prevState) => ({
        ...prevState,
        SK: {},
        um_name: {},
        um_email: {},
        um_contactNumber: {},
        um_role: {},
        um_location: {},
      }));
    } else if (action === "Edit") {
      setuserObj((prevState) => ({
        ...prevState,
        SK: props.rowdata.SK,
        um_status: props.rowdata.um_status,
        um_name: props.rowdata.um_name,
        um_role: props.rowdata.um_role,
        um_email: props.rowdata.um_email,
        um_contactNumber: props.rowdata.um_contactNumber,
        um_location: props.rowdata.um_location,
        um_empSalCode: props.rowdata.um_empSalCode,
      }));
    }
  };

  const handleAdd = async (e) => {
    let result;
    if (userObj.um_status === true) {
      userObj.um_status = "Active";
    } else {
      userObj.um_status = "Inactive";
    }

    if (action === "Add") {
      userObj.createdby = sessionStorage.getItem("UserId");
      userObj.PK = "UserMaster";
      result = AddNewUser(userObj);
    } else {
      result = UpdateUser(userObj);
    }
    result.then(async (resp) => {
      if (userObj.wld_profile !== "" && profile !== "") {
        const result = await getPresignedURL(folderName, userObj.wld_profile);
        const posturl = result.url;
        setPreviewUrl(posturl);
        await axios.put(posturl, profile);
      }
      if (resp.message) {
        showSuccess(resp.message);
      }
      props.setReload(!props.reload);
      setShowForm(false);
      props.onHide();
    }).catch((error) => {
      showWarning(`User Add/Update Failed:`);
      props.setReload(!props.reload);
      setShowForm(false);
      props.onHide();
    });

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!(await validate())) {
      if (validateInput()) {
        setShow1(true);
      }
    }
  };

  const showPopUp = (name, type, key, value) => {
    setPopUp({ name, type, key, value });
    setShowForm(true);
  };

  const updateUserRole = (result) => {
    setuserObj((prevState) => ({
      ...prevState,
      um_role: result.SK,
    }));
  };

  const setPopUpData = (data) => {
    const { name, result } = data;

    if (name === "Location") {
      setuserObj((prevState) => ({
        ...prevState,
        um_location: result.SK,
      }));
    } else if (name === "User Role") {
      updateUserRole(result);
    } else if (name === "PED User") {
      setuserObj((prevState) => ({
        ...prevState,
        SK: result.empEmailId ? result.empEmailId.split("@")[0] : "",
        um_name: result.empshortName,
        um_email: result.empEmailId,
        um_band: result.empBand,
        um_empSalCode: result.empSalCode,
      }));
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  const handleOndragOver = (event) => {
    event.preventDefault();
  };

  const fileInputRef = useRef(null);

  const handleFile = (file) => {
    const filevalid = validateFile(file)

    if (filevalid) {
      setProfile(file);
      setPreviewUrl(URL.createObjectURL(file));
      userObj.wld_profile = file.name;
    }
  };

  const fetchUserProfiles = async () => {
    try {
      if (userObj.wld_profile !== "") {
        const result = await getPresignedURL(folderName, userObj.wld_profile);
        const geturl = result.url;
        setPreviewUrl(geturl);

      }
    } catch (error) {
      if (error.request) {
        console.log("hii", error.request);
      } else {
        console.log("hiiiii", `Error: ${error.message}`);
      }
    }
  };

  useEffect(() => {
    fetchUserProfiles();
  }, []);

  const handleOndrop = (event) => {
    let imageFile = event.dataTransfer.files[0];
    handleFile(imageFile);
  };

  return (
    <>
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={show1}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || show || show1
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} User</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2 pb-2">
              <Row className="gx-3">
                <Col>
                  <Form.Group>
                    <div className="d-flex align-items-center">
                      <div className="g-input">
                        <input
                          style={{ width: "278px", height: "40px" }}
                          readOnly={true}
                          id="SK"
                          name="SK"
                          type="text"
                          maxLength="100"
                          disabled={action === "Edit" ? true : false}
                          className={
                            error.SK.status
                              ? "placeHolderInput inputText text-field-with-error"
                              : "placeHolderInput inputText"
                          }
                          placeholder=" "
                          color="var(--col-707070)"
                          value={userObj.SK}
                          onChange={handleChange}
                          onInput={(e) => {
                            let error = isAlphanumericWithDot(e.target.value);
                            setError((prevState) => ({
                              ...prevState,
                              SK: error,
                            }));
                          }}
                        />
                        <Form.Label className="required-field" htmlFor="SK">
                          User ID(EMail ID)
                        </Form.Label>
                        <BiSelectMultiple
                          className={action === "Edit" ? "d-none" : ""}
                          size={20}
                          onClick={() => {
                            showPopUp(
                              "PED User",
                              "Single",
                              "emailid",
                              userObj.SK
                            );
                            setError((prevState) => ({
                              ...prevState,
                              SK: {},
                              um_name: {},
                              um_email: {},
                              um_contactNumber: {},
                            }));
                          }}
                          color={"gray"}
                          style={{
                            marginLeft: "15.5rem",
                            marginTop: "-4.2rem",
                          }}
                        />
                      </div>
                    </div>
                    {error.SK.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "30px" }}>
                          {" "}
                          {error.SK.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <div className="d-flex align-items-center">
                      <div className="g-input">
                        <input
                          style={{ width: "278px", height: "40px" }}

                          readOnly={true}
                          name="um_name"
                          id="um_name"
                          type="text"
                          maxLength="100"
                          disabled={action === "Edit" ? true : false}
                          color="var(--col-707070)"
                          className={
                            error.um_name.status
                              ? "placeHolderInput inputText text-field-with-error"
                              : "placeHolderInput inputText"
                          }
                          placeholder=" "
                          value={userObj.um_name}
                          onChange={handleChange}
                          onInput={(e) => {
                            let error = isAlphanumericWithSpace(e.target.value);
                            setError((prevState) => ({
                              ...prevState,
                              um_name: error,
                            }));
                          }}
                        />
                        <Form.Label className="required-field" htmlFor="um_name">
                          Name of the person
                        </Form.Label>
                      </div>
                    </div>
                    {error.um_name.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "8px" }}>
                          {error.um_name.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <div className="d-flex align-items-center">
                      <div className="g-input">
                        <input
                          style={{ width: "278px", height: "40px" }}

                          readOnly
                          name="um_role"
                          id="um_role"
                          type="text"
                          className={
                            error.um_role.status
                              ? "placeHolderInput inputText text-field-with-error"
                              : "placeHolderInput inputText"
                          }
                          placeholder=" "
                          value={userObj.um_role}
                          onChange={handleChange}
                        />
                        <Form.Label className="required-field" htmlFor="um_role">
                          Role
                        </Form.Label>
                        <BiSelectMultiple
                          size={20}
                          onClick={() => {
                            showPopUp(
                              "User Role",
                              "Single",
                              "SK",
                              userObj.um_role
                            );
                            setError((prevState) => ({
                              ...prevState,
                              um_role: {},
                            }));
                          }}
                          color={"gray"}
                          style={{
                            marginLeft: "15.5rem",
                            marginTop: "-4.2rem",
                          }}
                        />
                      </div>
                    </div>
                    {error.um_role.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "30px" }}>
                          {error.um_role.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="gx-3" style={{ position: "relative", bottom: "12px" }}>
                <Col>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        className={
                          error.um_location.status
                            ? "placeHolderInput inputText text-field-with-error"
                            : "placeHolderInput inputText"
                        }
                        style={{ width: "278px", height: "40px" }}

                        name="um_location"
                        id="um_location"
                        type="text"
                        maxLength="10"
                        placeholder=" "
                        value={userObj.um_location}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericAllSpecialCharacters(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            um_location: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="um_location">
                        Location
                      </Form.Label>
                    </div>
                    {error.um_location.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "8px" }}>
                          {error.um_location.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        style={{ width: "278px", height: "40px" }}

                        className={
                          error.um_contactNumber.status
                            ? "placeHolderInput inputText text-field-with-error"
                            : "placeHolderInput inputText"
                        }
                        name="um_contactNumber"
                        id="um_contactNumber"
                        type="tel"
                        maxLength="10"
                        placeholder=" "
                        value={userObj.um_contactNumber}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumber(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            um_contactNumber: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="um_contactNumber">
                        Contact Number
                      </Form.Label>
                    </div>
                    {error.um_contactNumber.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "8px" }}>
                          {error.um_contactNumber.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="form-switch-input mt-1">
                    <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                    <Form.Switch
                      className={"semiBoldToggleButton " + (userObj.um_status ? "activeToggleLabel" : "inactiveToggleLabel")}
                      name="um_status"
                      checked={userObj.um_status}
                      onChange={handleSwitchChange}
                    />
                    <span className={"fieldLabel " + (userObj.um_status ? "activeToggleLabel" : "inactiveToggleLabel")}>
                      {userObj.um_status ? "Active" : "Inactive"}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
              <br></br>
              <Row style={{ position: "relative", bottom: "20px" }}>
                <Col md={4} sm={2}>
                  <Form.Group>
                    <h6>Signature Image</h6>
                    <form encType="multipart/form-data">
                      {userObj.wld_profile !== "" || previewUrl !== "" ? (
                        <div className="userpic_upload">
                          <img
                            src={previewUrl}
                            style={{
                              position: "relative",
                              left: "0px",
                              width: "100%",
                            }}
                            className="WPS-circler"
                          />
                          <img
                            src={Delete}
                            style={{
                              position: "relative",
                              top: "15px",
                              height: "30px",
                            }}
                            className="WPS-circlee"
                            onClick={() => {
                              setuserObj((prevState) => {
                                return { ...prevState, wld_profile: "" };
                              });
                              setPreviewUrl("");
                            }}
                          />
                        </div>
                      ) : (
                        <div className="userpic_upload">
                          <div
                            className="drop_zone"
                            onDragOver={handleOndragOver}
                            onDrop={handleOndrop}
                          >
                            <Form.Label
                              className="userpic_text_black"
                              htmlFor="fileInput"
                            >
                              Upload image here or
                            </Form.Label>{" "}
                            <Form.Label
                              className="userpic_text_blue"
                              htmlFor="fileInput"
                            >
                              Select a file
                            </Form.Label>
                            <br />
                            <Form.Label className="pic_text1" >
                              Supports: Jpeg, PNG and JPG, Size:Max 1MB
                            </Form.Label>
                            <br></br>
                            <Form.Label className="imgtext">
                              {userObj.wld_profile}
                            </Form.Label>
                            <input
                              id="fileInput"
                              name="fileInput"
                              type="file"
                              accept="image/*"
                              hidden
                              ref={fileInputRef}
                              onChange={(e) => handleFile(e.target.files[0])}
                            />
                          </div>
                        </div>
                      )}
                    </form>
                    &nbsp;&nbsp;
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>

          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>
          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>

      <RenderIf isTrue={popUp.type === "Single" && showForm}>
        <SingleValuePopUp
          show={showForm}
          onHide={() => setShowForm(false)}
          setSelected={setPopUpData}
          masterName={popUp.name}
          paramkey={popUp.key}
          paramvalue={popUp.value}
          backdrop="static"
        />
      </RenderIf>


    </>
  );
};

export default AddEditUserMaster;
